import React, { useState } from "react";
import { useAuth, formatApiErrorDetail } from "../lib/auth";
import { Sparkles, LogIn, Loader2 } from "lucide-react";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";

export default function Login() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  React.useEffect(() => {
    if (user) {
      window.location.href = "/";
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email.trim(), password);
      window.location.href = "/";
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 ambient-blobs grain relative overflow-hidden">
      <form
        onSubmit={handleSubmit}
        className="surface w-full max-w-md p-8 z-10 relative"
        data-testid="login-form"
      >
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-2xl gradient-saffron text-primary-foreground flex items-center justify-center glow-saffron shrink-0">
            <Sparkles className="w-5 h-5" />
          </div>
          <div>
            <div className="label-xs">Exotic India Art</div>
            <h1 className="font-serif text-2xl leading-none mt-1">Campaign Studio</h1>
          </div>
        </div>
        <p className="text-sm text-muted-foreground mb-5">
          Sign in to continue. <span className="italic gradient-saffron-text">Welcome back.</span>
        </p>

        <div className="flex flex-col gap-4">
          <div>
            <Label htmlFor="email" className="label-xs">Email</Label>
            <Input
              id="email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@exoticindia.com"
              className="mt-1 rounded-xl"
              data-testid="login-email"
              required
            />
          </div>
          <div>
            <Label htmlFor="password" className="label-xs">Password</Label>
            <Input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="•••••••"
              className="mt-1 rounded-xl"
              data-testid="login-password"
              required
            />
          </div>

          {err && (
            <div
              className="text-xs text-destructive bg-destructive/10 border border-destructive/30 rounded-xl px-3 py-2"
              data-testid="login-error"
            >
              {err}
            </div>
          )}

          <Button
            type="submit"
            disabled={busy}
            className="rounded-full glow-saffron gradient-saffron text-primary-foreground hover:opacity-95 mt-2"
            data-testid="login-submit"
          >
            {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <LogIn className="w-4 h-4 mr-2" />}
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </div>
      </form>
    </div>
  );
}
